import { ICS2ArrivalNotificationMessage } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';
import Ics2DeclarationErrors from 'views/declarations/common/declaration-errors-drawer/declaration-errors/ics2/Ics2DeclarationErrors';
import { errorsOf, toIcs2Notification } from '../arrivalMessageUtils';

type Props = {
    message: ICS2ArrivalNotificationMessage;
};

/**
 * Why customs rejected the arrival.
 *
 * The errors are the same structure the ENS side receives, so the list and the per-error detail
 * come from the shared components; only the next steps differ. An arrival has no amendment message
 * - a correction is a fresh submission under a new LRN - so the wording says to send it again
 * rather than to amend it.
 */
const IE3N99Details = ({ message }: Props) => (
    <Ics2DeclarationErrors
        errors={errorsOf(message)}
        latestNotification={toIcs2Notification(message)}
        nextSteps={
            <ul style={{ marginBottom: 0, listStyleType: 'initial' }}>
                <li>Correct the reported data on the arrival notification.</li>
                <li>Resolve every error listed before submitting again - customs reports them together.</li>
                <li>
                    Submit the arrival notification again. There is no amendment for an arrival, so it is sent as a new
                    message under a new LRN.
                </li>
                <li>Contact the customs office of first entry if the error persists.</li>
            </ul>
        }
    />
);

export default IE3N99Details;
